import { observable, makeObservable, action } from 'mobx';
import { handleHomeSearch, handleHomeNav } from '@/api/gateway';
import Toast from '@/components/Toast';
import { Storage } from '@/utils/Storage';
// import _ from 'lodash';
class HomeSearch {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        page: {
            page_num: 1,
            page_size: 10
        },
        templateId: -1,
        list: [],
        total: 0,
        nav: []
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };
    //切换tab时 设置id
    setTemplateId = (id) => {
        this.setState({
            templateId: id
        });
    };
    setPage = (page) => {
        this.setState({
            page: page
        });
    };
    //搜索结果
    handleHomeSearch = async (title) => {
        let portal_id = Storage.get('portal_id') || '';
        let data = {
            title: title,
            portal_id:portal_id,
            used_type:1, //使用类型1pc 2h5
            ...this.state.page
        };
        if (!this.state.nav.length) {
            return false;
        }
        if (this.state.templateId && this.state.templateId !== -1) {
            data.template_id = this.state.templateId;
        } else {
            let resId = this.state.nav.map((ele) => ele.template_id);
            data.template_id = resId.join(',');
        }

        let res = await handleHomeSearch(data);
        if (res && res.success) {
            console.log(res.data, '查询结果');
            this.setState({
                list: res.data,
                total: res.total
            });
        } else {
            this.setState({
                list: [],
                total: 0
            });
            Toast.error(res.msg || '查询失败');
        }
    };
    //首页导航
    handleHomeNav = async () => {
        let portal_id = Storage.get('portal_id');
        let res = await handleHomeNav({ portal_id });
        if (res && res.success) {
            console.log(res, '导航');
            this.setState({
                nav: res.data
            });
        } else {
            this.setState({
                nav: []
            });
        }
    };
}
export default new HomeSearch();
